import ConnectionIcon from 'app/common/presentation/Connection/ConnectionIcon'
import { AvailableConnection } from 'app/connections/types'

import styles from './ConnectionBrowser.module.scss'

export type ConnectionCardConnection = {
  description: string
  displayName: string
} & AvailableConnection
interface ConnectionCardProps {
  onClick: () => unknown
  connection: ConnectionCardConnection
}

const ConnectionCard = ({ onClick, connection: connection }: ConnectionCardProps) => (
  <div className={styles.card} onClick={onClick}>
    <ConnectionIcon connection={connection} />
    <div className={styles.name}>{connection.displayName}</div>
    <div className={styles.description}>{connection.description}</div>
  </div>
)

export default ConnectionCard
